import LocationAutocomplete from 'components/LocationAutocomplete';
import MakeModelMenu from 'components/Shared/MakeModelMenu';
import Dialog from 'components/Dialog';
import heatMapDemo from 'public/static/images/heat-map-demo.png';
import { useTranslation } from 'react-i18next';
import { locationAutocomplete } from 'lib/AutolistAPI';
import { screen } from 'components/styles/variables';
import Make from 'types/Make';
import Model from 'types/Model';
import ContentLocation from 'lib/ContentLocation';
import WindowLocation from 'lib/WindowLocation';

export default function AffordabilityRankings(): JSX.Element {
  const { t } = useTranslation();
  const push = WindowLocation.assign;

  function onSelectLocation(location: ContentLocation): void {
    const url = `${location.url}#section=affordability-rankings`;
    push(url);
  }

  function onSelectModel(make?: Make, model?: Model): void {
    if (model?.hasAnalysis) {
      const url = `${model.url}#section=affordability-rankings`;
      push(url);
    }
  }

  return (
    <div className="container">
      <a id="affordability-rankings" />
      <div className="row">
        <div className="col-xs-12 visible-xs">
          <h2 className="h2">{t('contentDashboard.affordabilityRankings')}</h2>
        </div>

        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div className="demo">
            <div>
              <img src={heatMapDemo} />
            </div>
            <div>
              <div className="hidden-xs">
                <h2 className="h2">{t('contentDashboard.affordabilityRankings')}</h2>
              </div>
              <div>
                <p>{t('contentDashboard.affordabilityText')}</p>
                <Dialog
                  button={({ toggle }): JSX.Element => (
                    <button data-location-link className="AL-button button" onClick={toggle}>
                      {t('contentDashboard.selectACity')}
                    </button>
                  )}
                  content={(): JSX.Element => (
                    <LocationAutocomplete<ContentLocation>
                      fetchResults={locationAutocomplete}
                      onSelect={onSelectLocation}
                      needsAttribution={false}
                    />
                  )}
                />
                <Dialog
                  button={({ toggle }): JSX.Element => (
                    <span className="or">
                      {t('contentDashboard.or')}
                      <button onClick={toggle} className="AL-link link" data-make-model-link>
                        {t('contentDashboard.selectMakeAndModel')}
                      </button>
                    </span>
                  )}
                  content={(): JSX.Element => (
                    <MakeModelMenu
                      allMakesAndModelsOption={true}
                      filter={(model: Model): boolean => !!model.url}
                      disabled={(model: Model): boolean => !model.hasAnalysis}
                      onSelect={onSelectModel}
                      mobileHeight="full"
                    />
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .demo {
            display: flex;
            flex-direction: column;
          }

          @media (min-width: ${screen.smMin}) {
            .demo {
              flex-direction: row;
              align-items: center;
            }
          }

          @media (min-width: ${screen.smMin}) {
            .demo > div:first-child {
              padding-right: 15px;
            }
          }

          @media (min-width: ${screen.smMin}) and (max-width: ${screen.smMax}) {
            .demo > div:first-child {
              flex-grow: 1;
            }
          }

          @media (min-width: ${screen.mdMin}) {
            .demo > div:first-child {
              width: 58%;
            }
          }

          @media (min-width: ${screen.smMin}) {
            .demo > div:last-child {
              padding-left: 15px;
            }
          }

          @media (min-width: ${screen.smMin}) and (max-width: ${screen.smMax}) {
            .demo > div:last-child {
              flex-grow: 1;
            }
          }

          @media (min-width: ${screen.mdMin}) {
            .demo > div:last-child {
              width: 42%;
            }
          }

          .demo img {
            width: 100%;
          }

          h2 {
            margin-bottom: 15px;
          }

          p {
            margin-bottom: 30px;
          }

          .button {
            display: block;
            margin: 0 auto 10px auto;
            width: 80%;
            font-size: 19px;
          }

          .link {
            font-size: 18px;
          }

          .or {
            display: block;
            text-align: center;
            font-size: 18px;
          }

          .or a {
            font-size: 18px;
          }
        `}
      </style>
    </div>
  );
}
